import { default as constants } from "./constants.min.js";

const utils = (function () {
	let validationErrors = [];

	function init() {
		return {
			addSpinner,
			clearFormErrors,
			clearFieldValidation,
			formatFileSize,
			formatPrice,
			delay,
			getRandomInt,
			getShuffledArr,
			hasHTMLTags,
			hideAjaxLoader,
			initChartJS,
			passwordCriteriaUI,
			removeSpinner,
			sanitizeInput,
			scrollToFirstError,
			sendDataLayerAnalyticsEvent,
			sendDataLayerRegistrationEvent,
			sendDownloadReportDataLayer,
			sendFTLInstitutionalDataLayer,
			showAjaxLoader,
			showFormFieldError,
			showFormFieldValid,
			showToast,
			showUploadFieldError,
			submitDisabledState,
			submitEnableState,
			toggleClassName,
			togglePasswordField,
			validateAlphaNumericHyphen,
			validateFieldMessage,
			validateFormField,
			validateEmailFormat,
			validationErrors,
			validatePasswordFormat,
			validateTelephone,
		};
	}

	function addSpinner($elm, static_pos) {
		$elm.prop("disabled", true);

		let $spinner = $elm.children(".spinner");
		$elm.addClass("relative");
		if ($spinner.length && !$spinner.hasClass("spinner-remove")) return null;
		!$spinner.length &&
			($spinner = $('<div class="spinner' + (static_pos ? "" : " spinner-absolute") + '"/>').appendTo($elm));
		_animateSpinner($spinner.find(".spinner"), "add");
	}

	function clearFormErrors($frm) {
		$frm.find(".is-invalid").removeClass("is-invalid");
		$frm.find(".invalid-feedback").remove();
	}

	function clearFieldValidation($frmField) {
		$frmField.removeClass("is-valid is-invalid");
		$frmField.siblings(".valid-feedback").remove();
		$frmField.siblings(".invalid-feedback").remove();
	}

	function delay(callback, ms) {
		var timer = 0;
		return function () {
			var context = this,
				args = arguments;
			clearTimeout(timer);
			timer = setTimeout(function () {
				callback.apply(context, args);
			}, ms || 0);
		};
	}

	function formatFileSize(size) {
		if (size >= 1024 * 1024) {
			return (Math.round((size / (1024 * 1024)) * 10) / 10).toFixed(1) + " MB";
		} else if (size >= 1024) {
			return Math.ceil(size / 1024) + " KB";
		} else {
			return size + " B";
		}
	}

	function formatPrice(price) {
		return Number((price / 100).toFixed(2)).toLocaleString();
	}

	function getRandomInt(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	const getShuffledArr = (arr) => {
		const newArr = arr.slice();
		for (let i = newArr.length - 1; i > 0; i--) {
			const rand = Math.floor(Math.random() * (i + 1));
			[newArr[i], newArr[rand]] = [newArr[rand], newArr[i]];
		}
		return newArr;
	};

	function hasHTMLTags(input) {
		const htmlTagRegex = /<\/?[a-z][\s\S]*>/i; // Regex to detect HTML tags
		return htmlTagRegex.test(input);
	}

	function hideAjaxLoader() {
		$("#ajaxLoader").delay(350).fadeOut("slow");
		$("body").delay(350).css({
			overflow: "visible",
		});
	}

	function initChartJS(classSelector = "", chartClassName = "", chartData = {}) {
		const items = document.querySelectorAll(classSelector);

		const observer = new IntersectionObserver(callbackFunction, {
			root: null,
			rootMargin: "-130px",
			threshold: 0.25,
		});

		items.forEach((item) => {
			observer.observe(item);
		});

		function callbackFunction(entries) {
			entries.forEach((entry) => {
				if (entry.isIntersecting && chartClassName !== "" && Object.keys(chartData).length > 0) {
					const ctx = document.getElementById(chartClassName);
					new Chart(ctx, chartData);

					observer.unobserve(entry.target);
				}
			});
		}
	}

	function passwordCriteriaUI($elm, $elmTarget, $elmBtn) {
		// Password Criteria
		$elm.on(
			"keyup",
			utils.delay(function () {
				let valid = true,
					passwordVal = $(this).val(),
					numberRegex = /\d/,
					lowercaseRegex = /[a-z]/,
					uppercaseRegex = /[A-Z]/,
					specialCharacterRegex = /[!@#\$%\^&\*]/; /* eslint-disable-line */

				// Check if minimum of 8 characters in length
				if (passwordVal.length >= 8) {
					$elmTarget.find(".js-min").addClass("valid");
				} else {
					valid = false;
					$elmTarget.find(".js-min").removeClass("valid");
				}

				// Check if string contains numbers
				if (numberRegex.test(passwordVal)) {
					$elmTarget.find(".js-number").addClass("valid");
				} else {
					valid = false;
					$elmTarget.find(".js-number").removeClass("valid");
				}

				// Check if string contains lowercase
				if (lowercaseRegex.test(passwordVal)) {
					$elmTarget.find(".js-lowercase").addClass("valid");
				} else {
					valid = false;
					$elmTarget.find(".js-lowercase").removeClass("valid");
				}

				// Check if string contains uppercase
				if (uppercaseRegex.test(passwordVal)) {
					$elmTarget.find(".js-uppercase").addClass("valid");
				} else {
					valid = false;
					$elmTarget.find(".js-uppercase").removeClass("valid");
				}

				// Check if string contains special character
				if (specialCharacterRegex.test(passwordVal)) {
					$elmTarget.find(".js-specialChar").addClass("valid");
				} else {
					valid = false;
					$elmTarget.find(".js-specialChar").removeClass("valid");
				}

				// if $elmBtn is available
				if ($elmBtn != undefined && valid) {
					$elmBtn.prop("disabled", false);
				}
			}, 500),
		);
	}

	function removeSpinner($elm, complete) {
		$elm.prop("disabled", false);

		let $spinner = $elm.children(".spinner");
		$spinner.length && _animateSpinner($elm.find(".spinner"), "remove", complete);
		$elm.removeClass("position-relative");
	}

	function sanitizeInput(input) {
		// Use a DOMParser to parse the input and remove HTML tags
		const tempDiv = document.createElement("div");
		tempDiv.textContent = input;
		return tempDiv.innerHTML; // Returns a sanitized string without tags
	}

	function scrollToFirstError($frm, $container = null) {
		// Find the first element with the .is-invalid class
		const $firstErrorElement = $frm.find(".is-invalid:eq(0)");

		if ($firstErrorElement.length) {
			// Calculate the position of the first error element
			const topPos = $firstErrorElement.offset().top - 80;

			if ($container) {
				// If a container is provided as a jQuery object, scroll within that container
				const containerElement = $container[0]; // Get the raw DOM element from the jQuery object

				// Calculate the scroll position within the container
				const containerTopPos = topPos + containerElement.scrollTop - $container.offset().top;

				$container.animate(
					{
						scrollTop: containerTopPos - 250, // Adjust the offset as needed
					},
					500,
				); // 500ms duration for smooth scroll
			} else {
				// If no container is provided, scroll the window
				window.scrollTo({
					top: topPos - 250, // Adjust the offset as needed
					behavior: "smooth",
				});
			}
		}
	}

	function sendDataLayerAnalyticsEvent(payload) {
		const obj = {
			event: "analytics_event",
			event_payload: {
				schema: "iglu:com.financialtimes/form_submission/jsonschema/1-0-3",
				data: payload,
			},
		};
		_sendDataLayers(obj);
	}

	function sendDataLayerRegistrationEvent(payload, user_id) {
		const obj = {
			event: "analytics_event",
			event_payload: {
				schema: "iglu:com.financialtimes/form_submission/jsonschema/1-0-3",
				data: payload,
			},
			user_id: user_id,
		};
		_sendDataLayers(obj);
	}

	function sendDownloadReportDataLayer($elm) {
		const obj = {
			event: "analytics_event",
			event_payload: {
				schema: "iglu:com.financialtimes/report_download/jsonschema/1-0-2",
				data: {
					report_id: Number($elm.data("key")),
					report_name: $elm.data("title"),
					report_category: $elm.data("category"),
					report_type: "Free Publication",
					report_price: 0,
				},
			},
		};
		_sendDataLayers(obj);
	}

	function sendFTLInstitutionalDataLayer(asset_type, system_product, system_product_cluster) {
		const obj = {
			event: "Page Entity Loaded",
			page: {
				data: {
					asset_type,
					system_product: "FTLocations",
					system_product_cluster: "Institutional",
					ft_pageview_id: Math.random() * 10000000000000000,
				},
			},
		};
		_sendDataLayers(obj);
	}

	function showAjaxLoader() {
		$("#ajaxLoader").delay(350).fadeIn("slow");
		$("body").delay(350).css({
			overflow: "hidden",
		});
	}

	function showFormFieldError($elm, msg = "") {
		$elm.parent(".relative").addClass("is-invalid");
		if (msg != "") {
			$('<div class="invalid-feedback">' + msg + "</div>").appendTo($elm.parents(".form-group"));
		}
	}

	function showFormFieldValid($elm, msg = "") {
		$elm.addClass("is-valid");
		if (msg != "") {
			$('<div class="valid-feedback">' + msg + "</div>").appendTo($elm.parent());
		}
	}

	function showToast(title = "Title", description = "Description", icon = "icon-fi-rr-check-alt") {
		const $toastElm = $("#toastCommon");
		const toast = new bootstrap.Toast($toastElm);

		$toastElm.find(".icon-brown").addClass(icon);
		$toastElm.find(".title").text(title);
		$toastElm.find(".description").text(description);
		toast.show();
	}

	function showUploadFieldError($elm, msg) {
		$elm.addClass("is-invalid");
		if (msg != "") {
			$('<div class="invalid-feedback text-start">' + msg + "</div>").appendTo($elm);
		}
	}

	function submitDisabledState($btnSubmit) {
		$btnSubmit.attr("disabled", true);
		addSpinner($btnSubmit);
	}

	function submitEnableState($btnSubmit) {
		$btnSubmit.attr("disabled", false);
		removeSpinner($btnSubmit);
	}

	function toggleClassName($elm, className) {
		$elm.toggleClass(className);
	}

	function togglePasswordField($this) {
		const $input = $this.parent(".form-inner").find("input.show-password");
		const inputType = $input.prop("type");
		const $btn = $this.parent(".form-inner").find("button.showPassword");

		if (inputType === "password") {
			$btn.addClass("show");
			$input.prop("type", "text");
		} else {
			$btn.removeClass("show");
			$input.prop("type", "password");
		}
	}

	// alpha numeric with hypen => https://stackoverflow.com/questions/8661254/javascript-only-allow-alphanumeric-and-hyphen-value-in-text-field
	function validateAlphaNumericHyphen(val) {
		const regex = /^[a-z0-9-]+$/i; /* eslint-disable-line */
		return regex.test(val);
	}

	function validateEmailFormat(email) {
		const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/; /* eslint-disable-line */
		return regex.test(email);
	}

	function validateFieldMessage($field, fieldName, maxLength = constants.MAX_LENGTH) {
		let isValid = true;

		if (!$field.val()) {
			const validationMessage = $field.data("validationmessage");
			utils.showFormFieldError($field, validationMessage);
			utils.validationErrors.push(`{"${fieldName}", "${validationMessage}"}`);
			isValid = false;
		} else if ($field.val().length > maxLength) {
			const validationMessageMax = $field.data("validationmessagemax").replace("{maxLength}", maxLength);
			utils.showFormFieldError($field, validationMessageMax);
			utils.validationErrors.push(`{"${fieldName}", "${validationMessageMax}"}`);
			isValid = false;
		}

		return isValid;
	}

	function validateFormField(value, flag, validatorVal) {
		if (value === undefined) {
			return false;
		}
		if (flag === constants.REQUIRED) {
			return value.trim().length > 0;
		}
		if (flag === constants.MIN_LENGTH) {
			return value.trim().length > validatorVal;
		}
		if (flag === constants.IS_NUMERIC) {
			return !isNaN(value.trim()) && value.trim() > validatorVal;
		}
	}

	function validatePasswordFormat(password) {
		const regex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/; /* eslint-disable-line */
		return regex.test(password);
	}

	function validateTelephone(value) {
		// Remove special characters and spaces for digit count check
		const numericValue = value.replace(/[^0-9]/g, "");

		// Check if it contains only valid characters and at least 7 digits
		const validFormat = /^[0-9+ -]+$/.test(value);
		const validDigitCount = numericValue.length >= 7;

		return validFormat && validDigitCount;
	}

	function _animateSpinner($elm, animation, complete) {
		if ($elm.data("animating")) {
			$elm.removeClass($elm.data("animating")).data("animating", null);
			$elm.data("animationTimeout") && clearTimeout($elm.data("animationTimeout"));
		}
		$elm.addClass("spinner-" + animation).data("animating", "spinner-" + animation);
		$elm.data(
			"animationTimeout",
			setTimeout(
				function () {
					animation == "remove" && $elm.remove();
					complete && complete();
				},
				parseFloat($elm.css("animation-duration")) * 1000,
			),
		);
	}

	function _sendDataLayers(obj) {
		window.dataLayer = window.dataLayer || [];

		// check if user is anonymous
		if ((obj.user_id === undefined && $("body").data("userid") === undefined) || $("body").data("userid") === 0) {
			obj.user_type = "Anonymous";
		} else {
			obj.user_type = "Registered";
			if (obj.user_id === undefined) {
				obj.user_id = $("body").data("userid");
			}
		}

		// push dataLayer
		window.dataLayer.push(obj);
	}

	return init();
})();

export default utils;
